import { Box, Button, Layer, Text } from 'grommet';
import { FormClose } from 'grommet-icons';
import { colors } from 'modules/root/theme';
import React, { useEffect } from 'react';
import { dispatchAction } from 'rxbeach';
import { connect } from 'rxbeach/react';
import { hideNotification, notification$ } from './notification$';
import { NotificationState } from './types';

const Notification = ({ success, error }: NotificationState) => {
  const open = Boolean(success || error);
  const message = success || error;

  const close = () => {
    dispatchAction(hideNotification());
  };

  useEffect(() => {
    setTimeout(() => dispatchAction(hideNotification()), 3000);
  }, [open]);

  if (!open) return null;
  const { background, color } = success ? colors.success : colors.danger;
  return (
    <Layer
      position="top"
      animation="fadeIn"
      modal={false}
      margin={{ top: 'xlarge' }}
      onEsc={close}
      onClickOutside={close}
      responsive={false}
      plain
    >
      <Box
        align="center"
        direction="row"
        gap="small"
        justify="between"
        round="medium"
        elevation="medium"
        pad="small"
        background={background}
      >
        <Box align="center" gap="xsmall" width="medium" color={color}>
          <Text>{message}</Text>
        </Box>
        <Button icon={<FormClose />} onClick={close} plain />
      </Box>
    </Layer>
  );
};

export default connect(Notification, notification$);
